/**
 * Gifts main — sale-grid countdown (updates .sale-chip values from end date).
 */
(function () {
  /**
   * @param {number} value
   * @returns {string}
   */
  const padTwo = (value) => String(Math.max(0, value)).padStart(2, '0');

  /**
   * @param {HTMLElement} grid
   */
  const initGiftsSaleCountdown = (grid) => {
    if (!(grid instanceof HTMLElement) || grid.dataset.giftsSaleCountdownInit === '1') {
      return;
    }

    const endRaw = grid.dataset.endDate;
    if (!endRaw) {
      return;
    }

    const endMs = new Date(endRaw).getTime();
    if (!Number.isFinite(endMs)) {
      return;
    }

    const daysEl = grid.querySelector('[data-countdown-days]');
    const hoursEl = grid.querySelector('[data-countdown-hours]');
    const minutesEl = grid.querySelector('[data-countdown-minutes]');
    const secondsEl = grid.querySelector('[data-countdown-seconds]');
    if (!daysEl || !hoursEl || !minutesEl || !secondsEl) {
      return;
    }

    grid.dataset.giftsSaleCountdownInit = '1';

    const section = grid.closest('.sale');
    const endText = grid.querySelector('[data-countdown-end-text]');
    const hideOnEnd = grid.dataset.hideOnEnd === 'true';

    /** @type {number | undefined} */
    let intervalId;

    const setZeros = () => {
      daysEl.textContent = '00';
      hoursEl.textContent = '00';
      minutesEl.textContent = '00';
      secondsEl.textContent = '00';
    };

    const tick = () => {
      const diff = endMs - Date.now();

      if (diff <= 0) {
        setZeros();
        grid.setAttribute('data-countdown-ended', 'true');

        if (endText instanceof HTMLElement) {
          endText.hidden = false;
        }

        if (hideOnEnd && section instanceof HTMLElement) {
          section.hidden = true;
        }

        if (intervalId) {
          window.clearInterval(intervalId);
        }
        return;
      }

      const days = Math.floor(diff / 86400000);
      const hours = Math.floor((diff % 86400000) / 3600000);
      const minutes = Math.floor((diff % 3600000) / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);

      daysEl.textContent = padTwo(days);
      hoursEl.textContent = padTwo(hours);
      minutesEl.textContent = padTwo(minutes);
      secondsEl.textContent = padTwo(seconds);
    };

    tick();
    intervalId = window.setInterval(tick, 1000);
  };

  const boot = () => {
    document.querySelectorAll('[data-gifts-sale-countdown]').forEach(initGiftsSaleCountdown);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLElement)) {
      return;
    }
    target.querySelectorAll('[data-gifts-sale-countdown]').forEach((grid) => {
      delete grid.dataset.giftsSaleCountdownInit;
      initGiftsSaleCountdown(grid);
    });
  });
})();
